<script>
    import StaticFacet from '/srv/web/wyvr/html/releases/58819/gen/client/shop/facet/StaticFacet.svelte?1733898724584';

    export let filter = {};
    export let products = [];
</script>

<div>
    <StaticFacet bind:filter {products} on:details />
</div>
<style>/* remove padding and grey background from default */</style>